import {
  toJsArray19cldvndk6qr4 as toJsArray,
  toByteArray18j13y992cujz as toByteArray,
} from './TargetUtilsJs.mjs';
import { hex2ofqpe9ngcu1i as hex } from './Crypto.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get__crypto() {
  _init_properties_Crypto_web_kt__nxveo7();
  return _crypto;
}
var _crypto;
function generateNonce() {
  _init_properties_Crypto_web_kt__nxveo7();
  var buffer = toJsArray(new Int8Array(16));
  get__crypto().getRandomValues(buffer);
  return hex(toByteArray(buffer));
}
var properties_initialized_Crypto_web_kt_8s9a0n;
function _init_properties_Crypto_web_kt__nxveo7() {
  if (!properties_initialized_Crypto_web_kt_8s9a0n) {
    properties_initialized_Crypto_web_kt_8s9a0n = true;
    _crypto = globalThis ? globalThis.crypto : window.crypto || window.msCrypto;
  }
}
//region block: exports
export {
  generateNonce as generateNonce1f4a9fru3x0v2,
};
//endregion

//# sourceMappingURL=Crypto.web.mjs.map
